import { render, staticRenderFns } from "./LikertCreation.vue?vue&type=template&id=603d412b&scoped=true&"
import script from "./LikertCreation.vue?vue&type=script&lang=js&"
export * from "./LikertCreation.vue?vue&type=script&lang=js&"
import style0 from "./LikertCreation.vue?vue&type=style&index=0&id=603d412b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "603d412b",
  null
  
)

export default component.exports